import type { MuscleGroupScoreResponse } from '../../api-v2-models/generated/MuscleGroupScoreResponse';
import type { PaginationResponse } from '../../api-v2-models/generated/PaginationResponse';
import type { PerformanceStat } from '../../api-v2-models/generated/PerformanceStat';
import type { Ride } from '../../api-v2-models/generated/Ride';
import type { Workout } from '../../api-v2-models/generated/Workout';
import { getUserWorkouts } from '../generated';
import type { AxiosPromise } from '../generated/core/request';

export const getUserWorkoutsWithMuscleGroupScore = (
  ...args: any[]
): AxiosPromise<
  PaginationResponse & {
    data: (Workout & { ride?: Ride })[];
    summary: Record<string, number>;
  } & {
    muscleGroupScore?: MuscleGroupScoreResponse;
    aggregateStats?: Array<PerformanceStat>;
    totalHeartRateZoneDurations?: {
      heartRateZ1Duration?: number;
      heartRateZ2Duration?: number;
      heartRateZ3Duration?: number;
      heartRateZ4Duration?: number;
      heartRateZ5Duration?: number;
    };
  }
> => getUserWorkouts.apply(this, args);
